/**
 * MembershipType Enum - Based on MembershipType.java
 * Types of memberships
 */
export enum MembershipType {
  FREE = 'FREE',
  PAYMENT = 'PAYMENT',
  NONE = 'NONE',
}

/**
 * Labels for membership types in Spanish
 */
export const MEMBERSHIP_TYPE_LABELS: Record<MembershipType, string> = {
  [MembershipType.FREE]: 'GRATIS',
  [MembershipType.PAYMENT]: 'PAGO',
  [MembershipType.NONE]: 'NINGUNO',
};
